import axios from '../../services/BaseService';

const api = process.env.REACT_APP_API_URL;

const getOrg = () => sessionStorage.getItem('cod_org') || '';
const getEmp = () => sessionStorage.getItem('cod_empresa') || '';

const headers = {
  'Content-Type': 'application/json',
  Accept: 'application/json',
};
const headersStatics = {};

export function setToken(token, cod_org) {
  if (cod_org) sessionStorage.setItem('cod_org', cod_org);
}

export function getUser(data, cod_org) {
  return axios.get(`${api}/menu/identificar/usuario/?number=${data}&cod_org=${cod_org}`);
}

export function createUser(data, org) {
  return axios.post(`${api}/menu/criar/usuario?cod_org=${org}`, data);
}

export function createOrderMenu(data) {
  return axios.post(`${api}/menu/pedido/criar`, data);
}

export function clienteAvisouPix(data) {
  return axios.post(`${api}/menu/pix/cliente-avisou`, data);
}

export function confirmarPix(cod_pedidomesa, data) {
  return axios.patch(
    `${api}/orders/confirmar-pix/${cod_pedidomesa}?cod_org=${getOrg()}&cod_empresa=${getEmp()}`,
    data
  );
}

export function createOrderVarejo(data) {
  return axios.post(`${api}/menu/varejo/pedido/criar`, data);
}

export function createAddress(data) {
  return axios.post(`${api}/menu/criar/endereco`, data);
}

export function deleteAddress(id) {
  return axios.delete(`${api}/menu/delete/endereco/?id=${id}`);
}

export async function getAddress(data) {
  let address = await axios.get(`${api}/menu/buscar/endereco/?number=${data}`);
  return address;
}

export function editAddress(id, data) {
  return axios.put(`${api}/menu/editar/endereco/?id=${id}`, data);
}

export function getUrl(url) {
  return axios.get(`${api}/menu/search-url/?url=${url}`);
}

export function getSections(company) {
  return axios.get(`${api}/menu/buscar/secoes/?company=${company}`);
}

export function getProductTamanho(id) {
  return axios.get(`${api}/menu/tamanhos?productId=${id}`);
}

export function getProductAdd(id, org) {
  return axios.get(`${api}/menu/add?productId=${id}&cod_org=${org}`);
}

export function getProductSabores(id) {
  return axios.get(`${api}/menu/sabores?productId=${id}`);
}

export function getOrdersByMenu(cellphone, id, org) {
  return axios.get(`${api}/menu/orders?cellphone=${cellphone}&cod_org=${org}`);
}

export function getOrderByIdMenu(id, org) {
  return axios.get(`${api}/menu/order?id=${id}&cod_org=${org}`);
}

export function getPreVendasVarejo(cellphone, org) {
  return axios.get(`${api}/menu/varejo/pedidos?cellphone=${cellphone}&cod_org=${org}`);
}

export function getPreVendaByIdVarejo(id, org) {
  return axios.get(`${api}/menu/varejo/pedido/detalhe?id=${id}&cod_org=${org}`);
}

export function getPaymentMethodByMenu() {
  return axios.get(`${api}/menu/meio-pagamento?cod_org=${getOrg()}`);
}

export function getPaymentMethodByMenuWithParam(org) {
  return axios.get(`${api}/menu/meio-pagamento?cod_org=${org}`);
}

export function getOrganizationMenu(org) {
  return axios.get(`${api}/menu/org-data?org=${org}`);
}

export function getMenuPrecos(org) {
  return axios.get(`${api}/menu/org-data?org=${org}`);
}

export function getServiceCharge() {
  return axios.get(`${api}/menu/service-charge?cod_org=${getOrg()}`);
}

export function getServiceChargeWithParam(org) {
  return axios.get(`${api}/menu/service-charge?cod_org=${org}`);
}

export function getOrders(order, page, limit, ordernation, all, startDate, endDate, tipoData) {
  let url = `${api}/order?cod_org=${getOrg()}&cod_empresa=${getEmp()}&order=${order}&page=${page}&limit=${limit}&ordernation=${ordernation}&all=${all}`;
  if (startDate) url += `&startDate=${encodeURIComponent(startDate)}`;
  if (endDate) url += `&endDate=${encodeURIComponent(endDate)}`;
  if (tipoData) url += `&tipoData=${tipoData}`;
  return axios.get(url, { headers });
}

// Lista leve do Kanban (sem itens/adicionais/produtos); o detalhe vem de getPedidoDetalhe.
export function getOrdersPainel() {
  return axios.get(`${api}/order?cod_org=${getOrg()}&cod_empresa=${getEmp()}&ordernation=ASC&resumo=2`, { headers });
}

// Pedido completo (itens, adicionais, sabores, tamanhos, pagamentos) ao abrir o card.
export function getPedidoDetalhe(cod_pedidomesa) {
  return axios.get(`${api}/order/detalhe?cod_org=${getOrg()}&cod_pedidomesa=${cod_pedidomesa}`, { headers });
}

// Endpoint enxuto para o safety-net do SocketListener: só retorna os campos
// necessários para detectar novos pedidos delivery em "analisando".
export function getOrdersResumo() {
  return axios.get(`${api}/order?cod_org=${getOrg()}&cod_empresa=${getEmp()}&resumo=1&all=todas&limit=1000&ordernation=ASC`, { headers });
}

// Lista leve para relatórios/listagens (ex.: ListarPedidos): resumo=2 traz
// cabeçalho + itens enxutos + resumo de pagamentos; o detalhe completo vem
// sob demanda via getPedidoDetalhe.
export function getOrdersResumoLista(startDate, endDate, tipoData, ordernation = 'DESC') {
  let url = `${api}/order?cod_org=${getOrg()}&cod_empresa=${getEmp()}&resumo=2&all=todos&limit=1000&ordernation=${ordernation}`;
  if (startDate) url += `&startDate=${encodeURIComponent(startDate)}`;
  if (endDate) url += `&endDate=${encodeURIComponent(endDate)}`;
  if (tipoData) url += `&tipoData=${encodeURIComponent(tipoData)}`;
  return axios.get(url, { headers });
}

// Nota única para um ou mais pedidos fechados juntos (autoatendimento gerencial).
export function emitirNotaFechamento(tipo, data) {
  const rota = tipo === 'NFE' ? 'nfe' : 'nfce';
  return axios.post(
    `${api}/order/nota-fiscal/${rota}?cod_org=${getOrg()}&cod_empresa=${getEmp()}`,
    data,
    { headers }
  );
}

export function createOrder(data) {
  // Se for QRCODE, usa a rota pública que acabamos de criar.
  // Caso contrário (garçom), usa a rota protegida padrão.
  const baseUrl = data.origem === 'QRCODE' ? `${api}/public/order/create` : `${api}/order/create`;
  const url = `${baseUrl}?cod_org=${getOrg()}&cod_empresa=${getEmp()}`;

  return axios.post(url, data, { headers });
}

export function updateOrderStatus(id, data) {
  return axios.patch(
    `${api}/order/update-status-order/?cod_pedidomesa=${id}&cod_org=${getOrg()}&cod_empresa=${getEmp()}`,
    data,
    { headers }
  );
}

// Confere na Motoka a programada de um pedido em "Aguardando" (cancelada no
// painel não gera webhook) e libera o pedido para novo despacho.
export function verificarDespachoLogistica(cod_pedidomesa) {
  return axios.post(
    `${api}/order/despachar/verificar?cod_pedidomesa=${cod_pedidomesa}&cod_org=${getOrg()}&cod_empresa=${getEmp()}`,
    {},
    { headers }
  );
}

export function confirmarAgendamento(id) {
  return axios.patch(
    `${api}/order/confirmar-agendamento/?cod_pedidomesa=${id}&cod_org=${getOrg()}&cod_empresa=${getEmp()}`,
    {},
    { headers }
  );
}

export function toggleOrderBlock(id, data) {
  return axios.patch(
    `${api}/order/toggle-block/?cod_pedidomesa=${id}&cod_org=${getOrg()}&cod_empresa=${getEmp()}`,
    data,
    { headers }
  );
}

export function closeOrder(id, data) {
  return axios.put(
    `${api}/order/close-order/?cod_pedidomesa=${id}&cod_org=${getOrg()}&cod_empresa=${getEmp()}`,
    data,
    { headers }
  );
}

export function closeMultipleOrders(data) {
  return axios.put(
    `${api}/order/close-multiple?cod_org=${getOrg()}&cod_empresa=${getEmp()}`,
    data,
    { headers }
  );
}

export function getClosureOrder(id) {
  return axios.get(
    `${api}/order/closure/?cod_org=${getOrg()}&cod_empresa=${getEmp()}&cod_pedidomesa=${id}`,
    { headers }
  );
}

export function getDeliveryCharge() {
  return axios.get(
    `${api}/order/delivery-charge/?cod_org=${getOrg()}&cod_empresa=${getEmp()}`,
    { headers }
  );
}

export function getAdditionalsByIdProduct(id, filtrarDescartaveis = false) {
  let url = `${api}/order/additionals/?id=${id}&cod_org=${getOrg()}&cod_empresa=${getEmp()}`;
  if (filtrarDescartaveis) {
    url += '&filtrarDescartaveis=true';
  }
  return axios.get(url, { headers });
}

export function getSaboressByIdProduct(id) {
  return axios.get(`${api}/order/sabores?id=${id}&cod_org=${getOrg()}&cod_empresa=${getEmp()}`, { headers });
}

export function getSaboresPreco(id, tamanhoDescricao) {
  return axios.get(
    `${api}/produto/precos?id=${id}&cod_org=${getOrg()}&cod_empresa=${getEmp()}&tamanho=${tamanhoDescricao}`,
    { headers }
  );
}

export function getSaboresPrecoMenu(id, tamanhoDescricao) {
  return axios.get(`${api}/menu/precos?id=${id}&cod_org=${getOrg()}&tamanho=${tamanhoDescricao}`, {
    headers,
  });
}

export function getOrdersConsumer(telefone) {
  return axios.get(
    `${api}/order/consumer/?cod_org=${getOrg()}&cod_empresa=${getEmp()}&telefone_cliente=${telefone}`,
    { headers }
  );
}

export function getTop10OrdersConsumer(origem) {
  const filtro = origem ? `&origem=${origem}` : '';
  return axios.get(`${api}/order/consumer-top10/?cod_org=${getOrg()}${filtro}`, { headers });
}

export function getOrderTables(status) {
  return axios.get(
    `${api}/mesa/order-tables?cod_org=${getOrg()}&cod_empresa=${getEmp()}&status=${status}`,
    { headers }
  );
}

export function deleteOrderTable(id, codMesa, codIpedidoMesa, auditData = {}) {
  return axios.delete(
    `${api}/order/delete?id=${id}&cod_mesa=${codMesa}&cod_org=${getOrg()}&cod_empresa=${getEmp()}&cod_ipedidomesa=${codIpedidoMesa}`,
    { headers, data: auditData }
  );
}

export function updateOrderTable(id, data) {
  // Fazemos a mesma lógica para a atualização (quando a mesa já está aberta)
  const url =
    data.origem === 'QRCODE'
      ? `${api}/public/order/update`
      : `${api}/order/update?id=${id}&cod_org=${getOrg()}&cod_empresa=${getEmp()}`;

  return axios.put(url, data, {
    headers: {
      ...headers,
      cod_org: getOrg(),
      cod_empresa: getEmp(),
    },
  });
}

export function getConsumers(consumer, page, sortKey, sortDirection, origem, segmento) {
  const filtro = origem ? `&origem=${origem}` : '';
  const filtroSegmento = segmento ? `&segmento=${segmento}` : '';
  return axios.get(
    `${api}/consumer?cod_org=${getOrg()}&consumer=${consumer}&page=${page}&sortKey=${sortKey || ''}&sortDirection=${sortDirection || ''}${filtro}${filtroSegmento}`,
    { headers }
  );
}

export function getRecentConsumerCount(origem) {
  const params = { cod_org: getOrg() };
  if (origem) params.origem = origem;
  return axios.get(`${api}/consumer/count-recent`, {
    params,
    headers,
  });
}

export function getInactiveConsumerCount(origem) {
  const params = { cod_org: getOrg() };
  if (origem) params.origem = origem;
  return axios.get(`${api}/consumer/count-inactive`, {
    params,
    headers,
  });
}

export function getPossiveisConsumerCount(origem) {
  const params = { cod_org: getOrg() };
  if (origem) params.origem = origem;
  return axios.get(`${api}/consumer/count-possiveis`, {
    params,
    headers,
  });
}

export function getSelectedConsumerAddress(consumer) {
  return axios.get(`${api}/parceiro/enderecos?cod_org=${getOrg()}&telefone=${consumer}`, {
    headers,
  });
}

export function createConsumer(data) {
  return axios.post(`${api}/consumer/create?cod_org=${getOrg()}`, data, { headers });
}

export function updateConsumer(data, id) {
  return axios.put(`${api}/consumer/update?id=${id}`, data, { headers });
}

export function getConsumerParceiro(id) {
  return axios.get(`${api}/consumer/${id}/parceiro`, { headers });
}

export function getConsumerResumo(id) {
  return axios.get(`${api}/consumer/${id}/resumo`, { headers });
}

export function deleteConsumer(id) {
  return axios.delete(`${api}/consumer/delete?id=${id}`, { headers });
}

export function createAddressConsumer(data) {
  return axios.post(`${api}/address/create`, data, { headers });
}

export function getAddressConsumer(telefone) {
  return axios.get(`${api}/address?cod_org=${getOrg()}&telefone=${telefone}`, { headers });
}

export function updateAddressConsumer(data, codParceiro) {
  return axios.put(`${api}/address/update?cod_parceiro=${codParceiro}`, data, { headers });
}

export function deleteAddressConsumer(codParceiro) {
  return axios.delete(`${api}/address/delete?cod_parceiro=${codParceiro}&cod_org=${getOrg()}`, { headers });
}

export function createPaymentMethod(data) {
  return axios.post(`${api}/meio-pagamento/create`, data, { headers });
}

export function getPaymentMethod(paymentMethod, page) {
  return axios.get(
    `${api}/meio-pagamento?paymentMethod=${paymentMethod}&cod_org=${getOrg()}&page=${page}`,
    { headers }
  );
}

export function getPaymentMethodAtivos() {
  return axios.get(`${api}/meio-pagamento/ativos?cod_org=${getOrg()}`, { headers });
}

export function updatePaymentMethod(data, id) {
  return axios.put(`${api}/meio-pagamento/update?cod_forma_pgto=${id}`, data, { headers });
}

export function deletePaymentMethod(id) {
  return axios.delete(`${api}/meio-pagamento/delete?cod_forma_pgto=${id}`, { headers });
}

export function storeCoverMenu(data) {
  return axios.post(`${api}/menu-admin/criar/capa?cod_org=${getOrg()}`, data, {
    headers: headersStatics,
  });
}

export function storeLogoMenu(data) {
  return axios.post(`${api}/menu-admin/criar/logo?cod_org=${getOrg()}`, data, {
    headers: headersStatics,
  });
}

export function getDataMenu() {
  return axios.get(`${api}/menu-admin/?cod_org=${getOrg()}`, { headers });
}

export function updateCoverMenu(data, oldPath, index) {
  return axios.put(
    `${api}/menu-admin/atualizar/capa?cod_org=${getOrg()}&old_path=${oldPath}&index=${index}`,
    data,
    { headers: headersStatics }
  );
}

export function updateLogoMenu(data, oldPath) {
  return axios.put(
    `${api}/menu-admin/atualizar/logo?cod_org=${getOrg()}&old_path=${oldPath}`,
    data,
    {
      headers: headersStatics,
    }
  );
}

export function updateDataMenu(data) {
  return axios.put(`${api}/menu-admin/atualizar/dados?cod_org=${getOrg()}`, data, { headers });
}

export function updateStatusStore(data) {
  return axios.put(`${api}/menu-admin/atualizar/status?cod_org=${getOrg()}`, data, { headers });
}

export function updateStatusStoreInMenu(data) {
  return axios.put(`${api}/menu/atualizar/status?cod_org=${getOrg()}`, data);
}

export function getMapaMesas() {
  return axios.get(`${api}/order/mapa-mesas?cod_org=${getOrg()}&cod_empresa=${getEmp()}`, { headers });
}

// Mapa leve da tela de mesas (sem itens/produtos); o detalhe vem de getPedidoDetalhe.
export function getMapaMesasResumo() {
  return axios.get(`${api}/order/mapa-mesas?cod_org=${getOrg()}&cod_empresa=${getEmp()}&resumo=1`, { headers });
}

export function calculateShipping(org, cepDestino, cartItems) {
  const itensStr = encodeURIComponent(JSON.stringify(cartItems));
  return axios.get(
    `${api}/menu/calculate-shipping?cod_org=${org}&cep_destino=${cepDestino}&itens=${itensStr}`
  );
}

// Estoque real por produto — exclusivo da vitrine /loja (varejo).
export function getEstoqueVarejo(org, produtoIds) {
  return axios.get(
    `${api}/menu/varejo/estoque?cod_org=${org}&produtos=${produtoIds.join(',')}`
  );
}

export async function cancelarItemPedidoAPI(dados, token) {
  // Ajustamos a rota para /order/item/cancelar e usamos a constante "api"
  const codOrg = getOrg();
  const codEmp = getEmp();
  const url = `${api}/order/item/cancelar?cod_org=${codOrg}&cod_empresa=${codEmp}`;
  const response = await axios.post(url, dados, {
    headers: {
      authorization: token,
      cod_org: codOrg,
      cod_empresa: codEmp,
    },
  });
  return response.data;
}

export function reprintOrderAPI(id, cod_org, tipoImpressao) {
  const cod_empresa = getEmp();
  return axios.post(
    `${api}/order/reprint?cod_pedidomesa=${id}&cod_org=${cod_org}&cod_empresa=${cod_empresa}`,
    { cod_org, tipoImpressao },
    {
      headers: {
        ...headers,
        cod_org: cod_org,
        cod_empresa: cod_empresa,
      },
    }
  );
}

export function listarFilaImpressaoAPI(cod_org) {
  const cod_empresa = getEmp();
  return axios.get(
    `${api}/order/fila-impressao?cod_org=${cod_org}&cod_empresa=${cod_empresa}`,
    {
      headers: {
        ...headers,
        cod_org: cod_org,
        cod_empresa: cod_empresa,
      },
    }
  );
}

export function pularImpressaoAPI(cod_pedidomesa, cod_org) {
  const cod_empresa = getEmp();
  return axios.post(
    `${api}/order/${cod_pedidomesa}/pular-impressao?cod_org=${cod_org}&cod_empresa=${cod_empresa}`,
    { cod_org },
    {
      headers: {
        ...headers,
        cod_org: cod_org,
        cod_empresa: cod_empresa,
      },
    }
  );
}

export function getRecommendations(cod_org, cartIdsStr) {
  return axios.get(`${api}/menu/recommendations?cod_org=${cod_org}&cart_ids=${cartIdsStr}`);
}

export function getMaisPedidos(org, limit = 5) {
  return axios.get(`${api}/menu/mais-pedidos?cod_org=${org}&limit=${limit}`);
}

export function updateOrderCustomer(data) {
  return axios.patch(
    `${api}/order/update-customer?cod_org=${getOrg()}&cod_empresa=${getEmp()}`,
    data,
    { headers }
  );
}

const contextoQuery = () => `cod_org=${getOrg()}&cod_empresa=${getEmp()}`;

export function updateParceiroAddress(data) {
  return axios.patch(`${api}/parceiro/endereco/telefone?${contextoQuery()}`, data, { headers });
}

// Um tb_parceiro por endereço (como no site): adicionar nunca sobrescreve outro endereço.
export function adicionarEnderecoParceiro(data) {
  return axios.post(`${api}/parceiro/endereco?${contextoQuery()}`, data, { headers });
}

export function editarEnderecoParceiro(codParceiro, data) {
  return axios.patch(`${api}/parceiro/endereco/${codParceiro}?${contextoQuery()}`, data, { headers });
}

export function emitirNfceDoPedidoApi(cod_pedidomesa) {
  const codOrg = getOrg();
  const codEmp = getEmp();
  return axios.post(
    `${api}/order/nfce/${cod_pedidomesa}?cod_org=${codOrg}&cod_empresa=${codEmp}`,
    {},
    {
      headers: {
        ...headers,
        cod_org: codOrg,
        cod_empresa: codEmp,
      },
    }
  );
}

export function emitirNfeDoPedidoApi(cod_pedidomesa) {
  const codOrg = getOrg();
  const codEmp = getEmp();
  return axios.post(
    `${api}/order/nfe/${cod_pedidomesa}?cod_org=${codOrg}&cod_empresa=${codEmp}`,
    {},
    {
      headers: {
        ...headers,
        cod_org: codOrg,
        cod_empresa: codEmp,
      },
    }
  );
}

export function updateItemPriceOrder(data) {
  const codOrg = getOrg();
  const codEmp = getEmp();
  return axios.patch(
    `${api}/order/item/update-price?cod_org=${codOrg}&cod_empresa=${codEmp}`,
    data,
    {
      headers: {
        ...headers,
        cod_org: codOrg,
        cod_empresa: codEmp,
      },
    }
  );
}

export function updateItemAdditionalsOrder(data) {
  const codOrg = getOrg();
  const codEmp = getEmp();
  return axios.patch(
    `${api}/order/item/update-additionals?cod_org=${codOrg}&cod_empresa=${codEmp}`,
    data,
    {
      headers: {
        ...headers,
        cod_org: codOrg,
        cod_empresa: codEmp,
      },
    }
  );
}

export function getMesaByGuid(guid) {
  return axios.get(`${api}/public/mesa/${guid}`);
}

export function criarSolicitacaoSenha(data) {
  const codOrg = getOrg();
  const codEmp = getEmp();
  return axios.post(`${api}/solicita-senha/criar`, data, {
    headers: { ...headers, cod_org: codOrg, cod_empresa: codEmp },
  });
}

// Ações do PDV que só existem no navegador (✖ no carrinho, F8): o backend valida a senha
// e registra o uso; a tela só executa a ação depois do 200.
export function validarSenhaExclusaoPdv(rota, data) {
  return axios.post(`${api}/solicita-senha/validar/${rota}`, data, {
    headers: { ...headers, cod_org: getOrg(), cod_empresa: getEmp() },
  });
}

export function getSolicitacoesSenhaPendentes() {
  const codOrg = getOrg();
  const codEmp = getEmp();
  return axios.get(`${api}/solicita-senha/pendentes`, {
    headers: { ...headers, cod_org: codOrg, cod_empresa: codEmp },
  });
}

export function responderSolicitacaoSenha(codSolsenha, data) {
  const codOrg = getOrg();
  const codEmp = getEmp();
  return axios.patch(`${api}/solicita-senha/${codSolsenha}/responder`, data, {
    headers: { ...headers, cod_org: codOrg, cod_empresa: codEmp },
  });
}

export function getPedidosAgendados(cod_org) {
  const codEmp = getEmp();
  return axios.get(
    `${api}/order/agendados?cod_org=${cod_org}&cod_empresa=${codEmp}`,
    { headers }
  );
}

export function getContadoresPainel(cod_org) {
  return axios.get(
    `${api}/order/contadores?cod_org=${cod_org}&cod_empresa=${getEmp()}`,
    { headers }
  );
}

export function getChamadaSenhas(cod_org) {
  return axios.get(
    `${api}/order/chamada-senhas?cod_org=${cod_org}&cod_empresa=${getEmp()}`,
    { headers }
  );
}

export function getPedidosCancelados(cod_org) {
  const codEmp = getEmp();
  return axios.get(
    `${api}/order/cancelados?cod_org=${cod_org}&cod_empresa=${codEmp}`,
    {
      headers: {
        ...headers,
        cod_org: cod_org,
        cod_empresa: codEmp,
      },
    }
  );
}

export function getCanceledOrders(startDate, endDate) {
  return axios.get(
    `${api}/order/canceled?cod_org=${getOrg()}&cod_empresa=${getEmp()}&startDate=${encodeURIComponent(startDate)}&endDate=${encodeURIComponent(endDate)}`,
    { headers }
  );
}

export function getItensExcluidos(startDate, endDate) {
  return axios.get(
    `${api}/order/itens-excluidos?cod_org=${getOrg()}&cod_empresa=${getEmp()}&startDate=${startDate}&endDate=${endDate}`,
    { headers }
  );
}

export function pausarLoja(cod_empresa, pausado_ate) {
  return axios.patch(
    `${api}/empresa/${cod_empresa}/pausar`,
    { pausado_ate },
    { headers }
  );
}

export function alterarModoChuva(cod_empresa, data) {
  return axios.patch(`${api}/empresa/${cod_empresa}/chuva`, data, { headers });
}

export function getEmpresa(cod_empresa) {
  return axios.get(`${api}/empresa/${cod_empresa}`, { headers });
}

export function consultarMotivosCancelamentoIfood(orderId) {
  return axios.get(
    `${api}/ifood/orders/${orderId}/cancellation-reasons`,
    { headers }
  );
}

export function cancelarPedidoIfood(orderId, motivo, cancellationCode = '509') {
  return axios.post(
    `${api}/ifood/orders/${orderId}/cancelar`,
    { motivo, cancellationCode },
    { headers }
  );
}

export function confirmarPedidoIfood(orderId) {
  return axios.post(
    `${api}/ifood/orders/${orderId}/confirmar`,
    {},
    { headers }
  );
}

export function despacharPedidoIfood(orderId) {
  return axios.post(
    `${api}/ifood/orders/${orderId}/despachar`,
    {},
    { headers }
  );
}
